export const blog_comments_data = [
  {
    key: '1',
    comment: 'Useful breakdown of HRMS evolution!',
    date: '12/09/2024',
    blog: 'The Evolution of HRMS: From Manual to Digital',
    by: 'Gertrude',
  },
  {
    key: '2',
    comment: 'Easy-to-follow HRMS guide!',
    date: '24/10/2024',
    blog: 'HRMS Implementation: A Step-by-Step Guide',
    by: 'Edward',
  },
  {
    key: '3',
    comment: 'Essential tips on HRMS data security!',
    date: '18/02/2024',
    blog: ' Data Security in HRMS: What Matters',
    by: 'Mark',
  },
  {
    key: '4',
    comment: 'Great HRMS recruitment tips',
    date: '17/10/2024',
    blog: 'Improving Recruitment with HRMS',
    by: 'Nidia',
  },
  {
    key: '5',
    comment: 'Great look at how HRMS affects culture',
    date: '20/07/2024',
    blog: 'Impact of HRMS on Company Culture',
    by: 'Rebecca',
  },
  {
    key: '6',
    comment: 'Valuable points on HRMS benefits',
    date: '10/04/2024',
    blog: ' Key Benefits of Implementing HRMS',
    by: 'Jimmy',
  },
  {
    key: '7',
    comment: 'Great points on why an HRMS is crucial',
    date: '29/08/2024',
    blog: 'Why Your Company Needs an HRMS',
    by: 'Richard',
  },
  {
    key: '8',
    comment: 'Great take on HRMS technology’s future',
    date: '22/02/2024',
    blog: 'The Future of HRMS Technology',
    by: 'Rachael',
  },
  {
    key: '9',
    comment: 'Valuable insights on scaling HR with HRMS!',
    date: '03/11/2024',
    blog: 'Scaling Your HR Operations with HRMS',
    by: 'Tammy',
  },
  {
    key: '10',
    comment: 'Useful points on how HRMS drives success',
    date: '17/12/2024',
    blog: 'How HRMS Drives Organizational Success',
    by: 'Judith',
  },
  ];